import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {

const history = useHistory();

  if (hasHiddenAuthButtons){
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>      
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={(() => {
            history.push('/')
          })}
        >
          Back to explore
        </Button>    
      </Box>
    );
  }

  return (
    <Box className="header">
      <Box className="header-title">
          <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>   
      {children}
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        {localStorage.getItem('username') ? <> 
        <Stack direction="row" alignItems="center" spacing={1}>
        <Avatar alt={localStorage.getItem('username')} src="avatar.png" />
        {localStorage.getItem('username')}
        </Stack> 
       <Button
        variant="text"
        onClick={(() => {
          // history.push('/login')
          localStorage.removeItem('balance');
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          window.location.reload()
        })}
      >
       Logout
      </Button>
      </> : <>
      <Button
        variant="text"
        onClick={(() => {
          history.push('/login')
        })}
      >
       Login
      </Button> 
      <Button
        variant="contained"
        onClick={(() => {
          history.push('/register')
        })}
      >
       Register
      </Button>
      </>
      }
        </Stack>    
    </Box>
  );
   
};

export default Header;
